const POST_ONBOARDING_PROFILE_KEY = "wowzer.redirectAfterOnboarding";

/** Call after successful Complete Profile — next app load goes to My Profile once. */
export function setPostOnboardingProfileRedirect() {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(POST_ONBOARDING_PROFILE_KEY, "1");
  } catch (_) {
    /* private mode / quota */
  }
}

/** Returns true once, then clears the flag. */
export function consumePostOnboardingProfileRedirect() {
  if (typeof window === "undefined" || !window.sessionStorage) return false;
  try {
    if (window.sessionStorage.getItem(POST_ONBOARDING_PROFILE_KEY) !== "1") {
      return false;
    }
    window.sessionStorage.removeItem(POST_ONBOARDING_PROFILE_KEY);
    return true;
  } catch (_) {
    return false;
  }
}

export function hasPostOnboardingProfileRedirect() {
  if (typeof window === "undefined" || !window.sessionStorage) return false;
  try {
    return window.sessionStorage.getItem(POST_ONBOARDING_PROFILE_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function getAuthenticatedLandingPath() {
  return hasPostOnboardingProfileRedirect()
    ? "/settings/profile"
    : "/organizations";
}
